import { Component, OnInit } from '@angular/core';
import {NavbarService} from '../../shared/services/navbar.service';
import {CountryGuideService} from '../../shared/services/countryGuide.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IWGSharedService } from '../../shared/services/shared.service';
@Component({
  selector: 'app-country-guide-detail',
  templateUrl: './country-guide-detail.component.html',
  styleUrls: ['./country-guide-detail.component.scss']
})
export class CountryGuideDetailComponent implements OnInit {

  countryGuideId: any;
  countryGuide: any;
  isLoading= false;
  id: number;
  regionId: 'null';
    showFooter = true
    embedStatus = "notembed"; 
  constructor(
      public nav: NavbarService,
      public countryGuideService: CountryGuideService,
      public router: Router,
      public route: ActivatedRoute,
      private sharedService: IWGSharedService, 
  ) { }

    getCountryGuideDetail = (isEmbed) => {
        this.isLoading = true;
    this.countryGuideService.getCountryGuidesDetail(this.countryGuideId, this.regionId)
        .subscribe(response => {
            if (isEmbed == true) {
                var index = response.data.Data.CountryGuideCategoryViews.findIndex(d => d.CategoryId === 2);
                response.data.Data.CountryGuideCategoryViews.splice(index, 1);
            }
           
            this.countryGuide = response.data.Data;
            this.isLoading = false;
        });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.countryGuideId = params.ID;
    });
     
     
      var isEmbed = this.sharedService.getIsEmbed();
      this.nav.show(isEmbed);
      if (isEmbed === true) {
          this.embedStatus = "embed"; 
          history.pushState(null, null, null);       
          window.addEventListener('popstate', () => {
              history.pushState(null, null, null);            
          });
        this.showFooter = false;
      } else {
          this.embedStatus = "notembed";        
        this.showFooter = true;
    }
      this.getCountryGuideDetail(isEmbed);
  }

}
